import { useEffect, useRef } from 'react';

export default function useAutoRefresh(callback: VoidFunction, delay: number, resetDependency?: unknown) {
  const savedCallback = useRef<VoidFunction>(() => null);

  // Remember the latest function
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    if (!delay || delay <= 0) {
      return undefined;
    }

    const intervalId = setInterval(() => savedCallback.current(), delay);

    return () => {
      clearInterval(intervalId);
    };
  }, [delay, resetDependency]);
}
